<template>
  <NuxtLink
    :to="location.link"
    :target="resolveLinkTarget(location.link)"
    :title="location.label"
  >
    <div :class="classListLocation">
      <span class="dbc-c-locations__label" :class="classListLabel">
        {{ location.label }}
      </span>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
const props = defineProps<{
  location: Location
}>()

const cities = [
  'berlin',
  'muenchen',
  'koeln',
  'frankfurt',
  'darmstadt',
  'hamburg',
  'stuttgart',
  'lueneburg',
  'offenbach',
]

const classListLocation = [
  cities.includes(props.location.city)
    ? 'dbc-c-locations__city'
    : 'dbc-c-locations__city dbc-c-locations__ice',
  `dbc-c-locations__${props.location.city}`,
]

const classListLabel = [
  cities.includes(props.location.city)
    ? 'dbc-c-locations__label--city'
    : 'dbc-c-locations__label--ice',
  `dbc-c-locations__label--${props.location.city}`,
]
</script>
